import { EmptyStub } from "ComponentsUI/EmptyStub";
import { Col } from "ComponentsUI/Styles/Grid";
import Button from "ComponentsUI/Button";
import React from "react";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { Link } from "react-router-dom";

export const CommonEmptyContentBlock = ({
	iconClass,
	title,
	description,
	onActionButtonClick,
	actionButtonText,
	linkTo,
}) => {
	const linkComponent = linkTo ? <Link to={linkTo} /> : null;

	return (
		<Container>
			<Row>
				<Col
					lg={{ size: 4, offset: 4 }}
					md={{ size: 4, offset: 4 }}
					sm={{ size: 4, offset: 4 }}
					xs={{ size: 6, offset: 3 }}
				>
					<EmptyStub
						header={title}
						text={description}
						icon={
							<span
								className={`icon48 ${iconClass}`}
								style={{
									fontSize: "48px",
									color: "#5812fe",
								}}
							/>
						}
						button={
							<Button
								typeText={"small"}
								size={"low"}
								status={"purple"}
								component={linkComponent}
								onClick={onActionButtonClick}
							>
								<span
									className="icon48 icon-playlist-add"
									style={{
										fontSize: "24px",
										color: "#d3cee1",
									}}
								/>
								{actionButtonText}
							</Button>
						}
					/>
				</Col>
			</Row>
		</Container>
	);
};
